import { memo } from "react";

function IndividualSeries({ style = {} }) {
  return (
    <svg width="36px" height="36px" viewBox="0 0 36 36" style={{ ...style }}>
      <g id="riconmapsum">
        <g id="riconmapsum">
          <path
            d="M0 0L36 0L36 36L0 36L0 0Z"
            id="Rectangle-Copy-7"
            fill="none"
            fillRule="evenodd"
            stroke="none"
          />
          <g id="sum" transform="translate(11 11)">
            <path
              d="M13.7586 14L0.24157 14C0.147184 14 0.0614842 13.9468 0.022177 13.864C-0.0171918 13.7811 -0.00289826 13.6836 0.0588965 13.6143L5.95713 6.99997L0.0585885 0.385694C-0.00295987 0.316429 -0.0174382 0.218874 0.0219306 0.136029C0.0612993 0.0531848 0.147184 0 0.24157 0L13.7586 0C13.8918 0 13.9999 0.104285 13.9999 0.233346L13.9999 3.73336C13.9999 3.86242 13.8918 3.96671 13.7586 3.96671L12.0689 3.96671C11.9356 3.96671 11.8275 3.86242 11.8275 3.73336L11.8275 2.1L5.09563 2.1L9.1179 6.85233C9.19054 6.93821 9.19054 7.06161 9.1179 7.14773L5.09563 11.9001L11.8276 11.9001L11.8276 10.2667C11.8276 10.1376 11.9357 10.0334 12.069 10.0334L13.7586 10.0334C13.8919 10.0334 14 10.1376 14 10.2667L14 13.7667C13.9999 13.8957 13.8921 14 13.7586 14L13.7586 14Z"
              id="Path"
              fill="currentColor"
              fillRule="evenodd"
              stroke="none"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default memo(IndividualSeries);
